<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="付款单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
               <el-form-item label="代理商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
			<el-form-item label="充值日期：" >
			    <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
            <el-form-item label="佣金状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="发放成功" value="1"></el-option>
                    <el-option label="发放失败" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getRecorListHandler">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column> 
            <el-table-column prop="orderNo" label="付款单号"></el-table-column>  
            <el-table-column prop="iccid" label="ICCID"></el-table-column>    
           <el-table-column prop="agentName" label="代理商"></el-table-column>  
            <el-table-column prop="price" label="佣金金额"></el-table-column>  
             <el-table-column  align="center"  label="支付状态" width="70">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.remark">
                        <p style="color:green"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.remark">
                        <p style="color:red"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column> 
            <el-table-column prop="createTime" label="发放时间" width="160"></el-table-column>

            <el-table-column  label="操作" width="140">
                <template v-slot="scope">
                    <el-button type="text" size="small" v-if="scope.row.payState==0" @click="showRefundDialog(scope.row.id)">重新发放</el-button>
                </template>
            </el-table-column>

        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true"  title="退款申请" :visible.sync="refundDialogVisible" width="600px" :close-on-click-modal="false" @close="cancelRefund()">

            <el-form ref="refundForm" :model="refundForm" :rules="refundRules" label-width="140px">
                <el-form-item label="付款单号：" >
                    <span>{{refundForm.orderNo}}</span>
                </el-form-item>

                <el-form-item label="退款金额(元)：" prop="priceRmb">
                    <el-input-number v-model="refundForm.priceRmb" :precision="2" :step="1" :min="0" :max="maxPriceRmb" clearable></el-input-number>
                </el-form-item>

                <el-form-item label="退款原因：" >
                    <el-input v-model="refundForm.remark" type="textarea"  maxlength="50" clearable></el-input>
                </el-form-item>

                <el-form-item label="凭证截图：" >
                    <el-upload class="avatar-uploader" action=""
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-change="handleAvatarSuccess">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>   
            <p style="color:red">确定后 会立即退回用户，并且所有赠送金失效</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelRefund()">取 消</el-button>
                <el-button type="primary" @click="applyRefundUser()">确 定</el-button>
            </div>       

        </el-dialog>
                 
    </div>
</template>
<script>
import {getBalanceRechargeRecordListss} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                orderNo: '',
                payOrder: null,
                payState:null,
				time: '',
                agentName:''

            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            refundDialogVisible: false,
            refundForm:{
                orderNo: '',
                priceRmb: '',
                remark: '',
                file: null,
            },
            maxPriceRmb:0,
            imageUrl: '',

            refundRules:{
                priceRmb: { required: true, message: '必填项', trigger: 'blur' },
            }
            
        }
    },
    methods: {

        getRecorListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getBalanceRechargeRecordListss(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })    
        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getRecorListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getRecorListHandler();
        },


        showRefundDialog(id){
             common.sysRequest('order/pc/user/investOrderss/back', {id:id}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                     this.getRecorListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(res.raw);
            this.refundForm.file = res.raw;
        },

        beforeAvatarUpload(file) {
            if(file){
                let isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                let isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                  this.$message.error('上传的图片只能是 JPG 或 PNG 格式!');
                }
                if (!isLt2M) {
                  this.$message.error('上传的图片大小不能超过 2MB!');
                }
                this.refundForm.file = file;
                return isJPG && isLt2M;
            }
            
            return true;
        }, 

        cancelRefund(){
            this.refundForm.priceRmb = '',
            this.refundForm.remark = '',
            this.refundForm.file = null;
            this.imageUrl = null;
            this.refundDialogVisible = false;
        },

        applyRefundUser(){
            if(this.refundForm.priceRmb == 0){
                this.$message.error("退款金额不能为0");
                return;
            }
            this.$refs.refundForm.validate(valid => {
                if(valid) {
                    if(this.beforeAvatarUpload(this.refundForm.file)){
                        let formData = new FormData();
                        Object.keys(this.refundForm).forEach((key) => {
                            formData.append(key, this.refundForm[key]);
                        });
                        common.sysRequest('order/applyRefundUsers', formData, 'post').then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                this.cancelRefund();
                                this.getRecorListHandler();
                            }else{
                               this.$message.error(res.data.message); 
                            }
                        })
                    }
                }
            })
        },

        investOrder(orderNo){
            common.sysRequest('order/sync/user/investOrder/'+orderNo, {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getRecorListHandler();
                }else{
                   this.$message.error(res.data.message); 
                }
            })
        },
        
    },
    created () {
        
    },

    mounted () {
       
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
        if(fromPage == 'userAccountFlowRecord'){
            this.searchForm.orderNo = fromPageOrderNo;
            this.getRecorListHandler();
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageOrderNo', '');
        }
        else{
            this.getRecorListHandler();
        }

        
    },

    computed:{
        fromPageOrderNo: function(){
            return this.$store.state.menu.fromPageOrderNo;
        },
    },

    watch: {
        fromPageOrderNo: function () {
            let fromPage = this.$store.state.menu.fromPage;
            let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
            if(fromPage == 'userAccountFlowRecord'){
                this.searchForm.orderNo = fromPageOrderNo;
                this.getRecorListHandler();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setFromPageOrderNo', '');
            }
        }
    },
}
</script>
<style lang="less" scoped>
    el-upload {
        border: 1px dashed #d9d9d9;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
        border: 1px dashed #d9d9d9;
    }
</style>

